import RequestForm from "../../../../core/model2/form/request-form"
import ProjectViews from "../../../../core/model2/project-view/project-views"
import asyncSessionLoader from "../../../../core/gd/data/async-session-loader"

// const debug = "editFormAction"
const debug = false

export default async function editFormAction(requestForm: RequestForm) {

    debug && console.log(debug, 'editFormAction', requestForm)

    // check if project exists
    const project = gd.session.projects.get(requestForm.projectId)
    if (!project) {
        console.warn('editFormAction: required project is not found', requestForm.projectId)
        return
    }

    // load possibly missing project data
    await asyncSessionLoader(gd.session.findMissing({
        projects            : [requestForm.projectId],
        projectsSettings    : [requestForm.projectId],
    }))

    // find request form project view
    const projectViews = ProjectViews.initByProjectId(requestForm.projectId)
    let view = projectViews.getFormView(requestForm.id)
    if (!view) {
        debug && console.log(debug, 'editFormAction createView', requestForm.projectViewConfig)

        // if request form project view hasn't been found then create new one
        view = await projectViews.createView(requestForm.projectViewConfig)
    }

    gd.navigation.goToForm(requestForm.projectId, view.id)
}